import qs from 'qs'
import Base from './base'

export default {
  get (username, password) {
    return Base
      .post('/token', qs.stringify({
        grant_type: 'password',
        username,
        password
      }))
      .then(res => res.data)
  }
}
